var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { getUsuarioPossuiNovasNotificacoes, setUsuarioVisualizouNotificacoes } from '../../api';
import { getTokenFromCookie } from '../../services/mt_login';
var NotificationContext = createContext(null);
var INTERVAL_DURATION = 300000; // 5 minutos
var BACKOFF_DURATION = 60000; // 1 minuto de espera após erro de rede
var criarNotificacaoLocal = function (notificacao, index, origem, notificacoesAtuais) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var id = (_a = notificacao.id) !== null && _a !== void 0 ? _a : "".concat(origem, "-").concat(index, "-").concat(String((_b = notificacao.titulo) !== null && _b !== void 0 ? _b : ''), "-").concat(String((_c = notificacao.mensagem) !== null && _c !== void 0 ? _c : ''));
    var notificacaoAtual = notificacoesAtuais.find(function (item) { return item.id === id; });
    return {
        id: id,
        titulo: (_d = notificacao.titulo) !== null && _d !== void 0 ? _d : 'Alerta',
        mensagem: (_e = notificacao.mensagem) !== null && _e !== void 0 ? _e : '',
        lida: (_g = (_f = notificacao.lida) !== null && _f !== void 0 ? _f : notificacaoAtual === null || notificacaoAtual === void 0 ? void 0 : notificacaoAtual.lida) !== null && _g !== void 0 ? _g : false,
        visualizada: (_j = (_h = notificacao.visualizada) !== null && _h !== void 0 ? _h : notificacaoAtual === null || notificacaoAtual === void 0 ? void 0 : notificacaoAtual.visualizada) !== null && _j !== void 0 ? _j : false,
        instituicao: (_k = notificacao.instituicao) !== null && _k !== void 0 ? _k : '',
        dataEncerramento: (_l = notificacao.dataEncerramento) !== null && _l !== void 0 ? _l : '',
        origem: origem,
        local: true,
    };
};
export var NotificacoesProvider = function (_a) {
    var children = _a.children;
    var _b = useState(localStorage.getItem('possueNovasNotificacoes') === 'true'), possueNovasNotificacoesServidor = _b[0], setPossueNovasNotificacoesServidor = _b[1];
    var _c = useState([]), notificacoesLocais = _c[0], setNotificacoesLocais = _c[1];
    var DEV = useState(process.env.AMBIENTE === 'DEV')[0];
    var intervalRef = useRef(null);
    var possueNovasNotificacoes = possueNovasNotificacoesServidor || notificacoesLocais.some(function (notificacao) { return !notificacao.visualizada; });
    var procurarNovasNotificacoes = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resposta, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getTokenFromCookie())
                        return [2 /*return*/];
                    DEV && console.log('procurarNovasNotificacoes');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getUsuarioPossuiNovasNotificacoes()];
                case 2:
                    Resposta = _a.sent();
                    if (Resposta === null || (Resposta === null || Resposta === void 0 ? void 0 : Resposta.Status) === 'ERRO') {
                        DEV && console.warn('procurarNovasNotificacoes: API inacessível, suspendendo intervalo por 1 min');
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                            intervalRef.current = null;
                        }
                        setTimeout(function () {
                            if (!intervalRef.current) {
                                intervalRef.current = setInterval(procurarNovasNotificacoes, INTERVAL_DURATION);
                                procurarNovasNotificacoes();
                            }
                        }, BACKOFF_DURATION);
                        return [2 /*return*/];
                    }
                    setPossueNovasNotificacoesServidor(Resposta);
                    localStorage.setItem('possueNovasNotificacoes', Resposta ? 'true' : 'false');
                    localStorage.setItem('lastCheckTimestamp', Date.now().toString());
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao verificar novas notificações:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [DEV]);
    var registrarNotificacoesLocais = useCallback(function (origem, notificacoes) {
        if (notificacoes === void 0) { notificacoes = []; }
        setNotificacoesLocais(function (notificacoesAtuais) {
            var notificacoesDeOutrasOrigens = notificacoesAtuais.filter(function (notificacao) { return notificacao.origem !== origem; });
            var novasNotificacoes = (notificacoes || []).map(function (notificacao, index) { return criarNotificacaoLocal(notificacao, index, origem, notificacoesAtuais); });
            return __spreadArray(__spreadArray([], notificacoesDeOutrasOrigens, true), novasNotificacoes, true);
        });
    }, []);
    var marcarNotificacaoLocal = useCallback(function (id, lida) {
        setNotificacoesLocais(function (notificacoesAtuais) {
            return notificacoesAtuais.map(function (notificacao) { return (notificacao.id === id ? __assign(__assign({}, notificacao), { lida: lida, visualizada: true }) : notificacao); });
        });
    }, []);
    var marcarTodasNotificacoesLocais = useCallback(function (lida) {
        setNotificacoesLocais(function (notificacoesAtuais) { return notificacoesAtuais.map(function (notificacao) { return (__assign(__assign({}, notificacao), { lida: lida, visualizada: true })); }); });
    }, []);
    var visualizarNotificacoesNovas = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!possueNovasNotificacoesServidor) return [3 /*break*/, 2];
                    return [4 /*yield*/, setUsuarioVisualizouNotificacoes()];
                case 1:
                    _a.sent();
                    setPossueNovasNotificacoesServidor(false);
                    localStorage.setItem('possueNovasNotificacoes', 'false');
                    _a.label = 2;
                case 2:
                    setNotificacoesLocais(function (notificacoesAtuais) { return notificacoesAtuais.map(function (notificacao) { return (__assign(__assign({}, notificacao), { visualizada: true })); }); });
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var lastCheckTimestamp = Number.parseInt(localStorage.getItem('lastCheckTimestamp') || '0', 10);
        var timeSinceLastCheck = Date.now() - lastCheckTimestamp;
        var initialDelay = Math.max(INTERVAL_DURATION - timeSinceLastCheck, 0);
        var initialTimeoutId = setTimeout(function () {
            procurarNovasNotificacoes();
            intervalRef.current = setInterval(procurarNovasNotificacoes, INTERVAL_DURATION);
        }, initialDelay);
        return function () {
            clearTimeout(initialTimeoutId);
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [procurarNovasNotificacoes]);
    return (_jsx(NotificationContext.Provider, __assign({ value: {
            possueNovasNotificacoes: possueNovasNotificacoes,
            visualizarNotificacoesNovas: visualizarNotificacoesNovas,
            notificacoesLocais: notificacoesLocais,
            registrarNotificacoesLocais: registrarNotificacoesLocais,
            marcarNotificacaoLocal: marcarNotificacaoLocal,
            marcarTodasNotificacoesLocais: marcarTodasNotificacoesLocais,
        } }, { children: children })));
};
export var useNotificacoes = function () {
    var context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotificacoes deve ser usado dentro de um NotificacoesProvider');
    }
    return context;
};
export default NotificationContext;
